export default __webpack_public_path__ + "static/media/display_sarisari.f45368df.png";